import React from 'react';
import { Link } from 'react-router-dom';
import './index.scss';

import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream';

export default ({
  trackingId,
  href,
  spaHREF,
  ...props
}) => {
  const { locale, learnLanguageCode } = useRouteParamsContext();

  const trackClick = () => {
    if (props.inProgress || !props.disabled) {
      trackGuiInteracted({
        locale,
        learnLanguageCode,
        guiElementName: trackingId
      });
    }
  };

  const handleClick = () => {
    trackClick();
    if (props.onClick) {
      props.onClick();
    }
  };

  if (spaHREF) {
    return (
      <Link
        {...props}
        to={spaHREF}
        onClick={handleClick}
      />
    );
  }

  return (
    <a
      {...props}
      href={href}
      onClick={handleClick}
    />
  );
};
